import { RouteConfig } from 'vue-router';
import children from '../routes-children/ui-lib';

export default <RouteConfig> {
	name: 'uiLib',
	path: "/ui-lib",
	component: () => import('../../views/UILib/UILib.vue'),
	children
};